import { Component, ElementRef, ViewChild, OnInit, Output, EventEmitter } from '@angular/core';
import { ComponentBase } from 't4core';
import { BookingService } from 'app-components';
import { animate, style, transition, trigger } from '@angular/animations';
import { Coordinates } from 't4-app-integration';
import { FormControl } from '@angular/forms';
import { AppSearchComponent } from '../app-search/app-search';
@Component({
    selector: 'app-place-search',
    templateUrl: './place-search.html',
    animations: [
        trigger('inOutAnimation', [
            transition(':enter', [
                style({ marginLeft: '-200px' }),
                animate('0.2s ease-out', style({ marginLeft: '0' }))
            ])
        ])
    ],
    standalone: false
})
export class PlaceSearchComponent extends ComponentBase implements OnInit {
  @Output()
  public placeSelected: EventEmitter<Coordinates> = new EventEmitter<Coordinates>();

  @ViewChild('appSearch')
  private appSearch!: AppSearchComponent;

  searchControl: FormControl;
  private searchBox!: google.maps.places.Autocomplete;
  private listener!: google.maps.MapsEventListener;
  private isResetting = false;
  constructor(public bookingService: BookingService) {
    super();
  }

  public ngOnInit() {
    this.searchControl = new FormControl();
    setTimeout(() => {
      this.initGoogle();
      this.appSearch.getInput().focus();
    }, 100);
  }

  public clearSearch() {
    const input = this.appSearch.getInput();
    input.value = '';
  }

  public handleEnter() {
    if (this.isResetting) return;

    const input = this.appSearch.getInput();
    const downArrow = new KeyboardEvent('keydown', { bubbles: true, keyCode: 40, key: 'ArrowDown' });
    const enterKey = new KeyboardEvent('keydown', { bubbles: true, keyCode: 13, key: 'Enter' });

    setTimeout(() => {
      input.dispatchEvent(downArrow);

      setTimeout(() => {
        this.isResetting = true;
        input.dispatchEvent(enterKey);

        setTimeout(() => {
          this.isResetting = false;
        }, 150);
      }, 50);
    }, 50);
  }

  private async initGoogle() {
    const { } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;

    const input = this.appSearch.getInput();

    this.searchBox = new google.maps.places.Autocomplete(input, {
      componentRestrictions: { country: ['NO', 'SE', 'DK', 'DE', 'IS'] },
      types: ['locality', 'neighborhood', 'sublocality'],
      fields: ['geometry']
    });

    input.focus();

    this.listener = this.searchBox.addListener("place_changed", () => {
      let place: google.maps.places.PlaceResult = this.searchBox.getPlace();
      if (place.geometry) {
        this.placeSelected.emit({
          Latitude: place.geometry.location.lat(),
          Longitude: place.geometry.location.lng()
        });
      }
    });
  }
}
